import * as THREE from "three";

function createLetterTexture(chars) {
  const isHighRes = window.devicePixelRatio > 1.2;
  const multiplier = isHighRes ? 2 : 1;
  const fontSize = 16 * multiplier;
  const verticalOffset = 0;
  const letterBox = 16 * multiplier;
  const itemsPerSide = 4;
  const canvas = document.createElement("canvas");
  const side = letterBox * itemsPerSide;
  const ctx = canvas.getContext("2d");
  const offset = letterBox / 2;

  canvas.width = side;
  canvas.height = side;

  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `500 ${fontSize}px Arial`;

  const textureCoords = [];
  const textureCoordsMap = [];

  for (let i = 0; i < chars.length; i++) {
    const col = Math.floor(i / itemsPerSide);
    const row = i % itemsPerSide;
    const x = row * letterBox + offset;
    const y = col * letterBox + offset + verticalOffset;
    const char = chars[i];

    ctx.fillStyle = "black";
    ctx.fillText(char.char, x, y);

    textureCoordsMap[char.code] = textureCoords.length;
    textureCoords.push(
      new THREE.Vector4(
        row / itemsPerSide,
        col / itemsPerSide,
        0.9 / itemsPerSide,
        0.9 / itemsPerSide
      )
    );
  }

  const texture = new THREE.Texture(canvas);
  canvas.remove();
  texture.flipY = false;
  texture.needsUpdate = true;

  return { texture, textureCoords, textureCoordsMap, itemsPerSide };
}

export default createLetterTexture;
